import * as React from 'react';
import * as mrCap from '../../mrCapTypes';
import format from 'date-fns/format';
import sv from 'date-fns/locale/sv';

interface CarDetailsBoxProps {
  regnr: string | undefined;
  carDetails: mrCap.VehicleInfo;
}

export function CarDetailsBox({ regnr, carDetails }: CarDetailsBoxProps) {
  return (
    <div className='car-details'>
      <div className='car-detail'>
        <i className='fas fa-fingerprint'></i><strong>Reg. nummer</strong>
        <span>{regnr?.toUpperCase()}</span></div>

      <div className='car-detail'>
        <i className='fas fa-tag'></i><strong>Modell</strong>
        <span>{carDetails.brand + ', ' + carDetails.model}</span></div>

      <div className='car-detail'>
        <i className='fas fa-paint-brush'></i><strong>Färg</strong>
        <span>{carDetails.color}</span></div>

      <div className='car-detail'>
        <i className='fas fa-calendar-check'></i><strong>Reg. år</strong>
        <span>{format(carDetails.registrationDate, 'yyyy', {locale: sv})}</span></div>
    </div>
  );
}